import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

import {
  ref,
  onMounted,
  watch,
  Ref,
  PropType,
  nextTick,
  computed,
} from 'vue'
import { useI18n } from 'vue-i18n'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import InputWithUnit from '@/components/InputWithUnit.vue'
import { splitLastCharacter } from '@/common/tools'
import { RefreshLeft, Search } from '@element-plus/icons-vue'

import FormRulesFactory from '@/common/formRules'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'EvseProflieSchedule',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isView: {
    type: Boolean,
    required: false,
  },
  connectorNum: {
    type: Number,
    default: 1,
  },
  isLately: {
    type: Boolean,
    default: false,
  },
  schedule: {
    type: Object as PropType<Record<string, any>>,
    required: false,
    default: () => ({}),
  },
},
  emits: ['update:schedule', 'search:lateLy'],
  setup(__props, { expose, emit }) {

const props = __props

const profileScheduleFormRule = ref({
  ...FormRulesFactory.generateCustomRules(['startPeriod'], 'inputEmpty', 'inputInvalid', {
    removeZeroCheck: true,
  }),
  ...FormRulesFactory.generateCustomRules(
    ['limit', 'minChargingRateInfo'],
    'inputEmpty',
    'inputInvalid',
  ),
  ...FormRulesFactory.generateCustomRules(['numberPhases'], 'inputEmpty', 'inputInvalid', {
    removeZeroCheck: true,
    pattern: /^[0-3]$/,
  }),
})
const { t } = useI18n()



const connectorOptions = computed(() => {
  if (props.connectorNum === 1) {
    return [
      {
        value: 1,
        label: t('Evses.cno') + `1`,
      },
    ]
  }
  // 生成多个选项的逻辑
  return Array.from({ length: props.connectorNum }, (_, i) => ({
    value: i + 1,
    label: t('Evses.cno') + `${i + 1}`,
  }))
})
const disabledCno = computed(() => props.connectorNum === 1)

const createRawFormData = () => ({
  chargingRateUnit: '',
  chargingSchedulePeriod: [],
  duration: null,
  minChargingRate: 0,
  startSchedule: '',
  minChargingRateInfo: '',
})

const defaultUnit = ref('A')
const scheduleForm = ref<InstanceType<typeof import('element-plus/es')['ElForm']>>()

const scheduleRecord: Ref<Record<string, any>> = ref(createRawFormData())

const addTabdata = () => {
  let tmp = {
    startPeriod: null,
    numberPhases: null,
    limit: null,
  }
  scheduleRecord.value.chargingSchedulePeriod.push(tmp)
}

const disableAdd = (row: any) => {
  if (scheduleRecord.value.chargingSchedulePeriod.length > 20) return true
  return false
}

const delTabdata = (row: any) => {
  scheduleRecord.value.chargingSchedulePeriod.forEach((v, k) => {
    if (v === row) {
      scheduleRecord.value.chargingSchedulePeriod.splice(k, 1)
    }
  })
}
onMounted(() => {
  scheduleRecord.value = { ...createRawFormData(), ...props.schedule }
  scheduleRecord.value.minChargingRateInfo =
    scheduleRecord.value.minChargingRate + scheduleRecord.value.chargingRateUnit
  scheduleRecord.value.duration =
    scheduleRecord.value.duration === 0 ? null : scheduleRecord.value.duration
})

expose({
  scheduleRecord,
  validate: async () => {
    // 等待组件的 el-form 渲染完成
    await nextTick()
    if (scheduleForm.value) {
      // 返回 validate 的 Promise
      return scheduleForm.value.validate()
    } else {
      throw new Error('scheduleForm not initialized')
    }
  },
  resetFields: async () => {
    // 确保组件的 el-form 渲染完成
    await nextTick()
    if (scheduleForm.value) {
      // 调用 resetFields 方法
      scheduleForm.value.resetFields()
    } else {
      throw new Error('scheduleForm not initialized')
    }
  },
  clearValidate: async () => {
    // 确保组件的 el-form 渲染完成
    await nextTick()
    if (scheduleForm.value) {
      // 调用 clearValidate 方法
      scheduleForm.value.clearValidate()
    } else {
      throw new Error('scheduleForm not initialized')
    }
  },
})
// watch(
//   () => props.schedule, // 监听 props 中的 schedule
//   (newSchedule) => {
//     // 当 schedule 变化时，更新 scheduleRecord
//     if (newSchedule) {
//       scheduleRecord.value = { ...createRawFormData(), ...newSchedule }
//       scheduleRecord.value.minChargingRateInfo =
//         scheduleRecord.value.minChargingRate + scheduleRecord.value.chargingRateUnit
//     }
//   },
//   { immediate: true }, // 立即执行一次，以确保初始值被设置
// )
// watch(
//   scheduleRecord,
//   (newRecord) => {
//     if (newRecord.minChargingRateInfo.length > 1) {
//       const chargingRate = splitLastCharacter(newRecord.minChargingRateInfo, 1)
//       if (chargingRate.lastChar == 'A' || chargingRate.lastChar == 'W') {
//         scheduleRecord.value.minChargingRate = Number(chargingRate.beforeLast) || 0
//         scheduleRecord.value.chargingRateUnit = chargingRate.lastChar
//       }
//     }
//     emit('update:schedule', { ...scheduleRecord.value })
//   },
//   { deep: true }, // 深度监听，确保对象内部的变化也能被监听到
// )
const isUpdatingFromProps = ref(false)
const isUpdatingFromRecord = ref(false)

watch(
  () => props.schedule,
  (newSchedule) => {
    if (!isUpdatingFromRecord.value && newSchedule) {
      isUpdatingFromProps.value = true
      scheduleRecord.value = { ...createRawFormData(), ...newSchedule }
      scheduleRecord.value.minChargingRateInfo =
        scheduleRecord.value.minChargingRate + scheduleRecord.value.chargingRateUnit
      isUpdatingFromProps.value = false
    }
  },
)

watch(
  scheduleRecord,
  (newRecord) => {
    if (!isUpdatingFromProps.value && newRecord.minChargingRateInfo.length > 1) {
      const chargingRate = splitLastCharacter(newRecord.minChargingRateInfo, 1)
      if (chargingRate.lastChar === 'A' || chargingRate.lastChar === 'W') {
        scheduleRecord.value.minChargingRate = Number(chargingRate.beforeLast) || 0
        scheduleRecord.value.chargingRateUnit = chargingRate.lastChar
      }
    }
    isUpdatingFromRecord.value = true
    // emit('update:schedule', { ...scheduleRecord.value })
    isUpdatingFromRecord.value = false
  },
  { deep: true },
)
const handleSearch = () => {
  emit('search:lateLy', scheduleRecord.value)
}
const handleReset = () => {
  scheduleRecord.value.cno = null
  scheduleRecord.value.duration = null
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "scheduleForm",
    ref: scheduleForm,
    model: scheduleRecord.value,
    "validate-on-rule-change": false
  }, {
    default: _withCtx(() => [
      (props.isLately)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            gutter: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { prop: "cno" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: scheduleRecord.value.cno,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((scheduleRecord.value.cno) = $event)),
                        disabled: _unref(disabledCno),
                        placeholder: _ctx.$t('Evses.cno')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(connectorOptions), ({ label, value }) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: value,
                              value: value,
                              label: label
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { prop: "duration" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: scheduleRecord.value.duration,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((scheduleRecord.value.duration) = $event)),
                        placeholder: _unref(t)('Evses.duration'),
                        disabled: props.isView,
                        type: "number",
                        min: 0
                      }, null, 8, ["modelValue", "placeholder", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 4,
                class: "col-oper"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        plain: "",
                        icon: _unref(Search),
                        onClick: handleSearch
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                        ]),
                        _: 1
                      }, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        icon: _unref(RefreshLeft),
                        onClick: handleReset
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                        ]),
                        _: 1
                      }, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_row, {
            key: 1,
            gutter: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { prop: "startSchedule" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: scheduleRecord.value.startSchedule,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((scheduleRecord.value.startSchedule) = $event)),
                        type: "date",
                        placeholder: _ctx.$t('Evses.startScheduleTime'),
                        clearable: "",
                        disabled: props.isView
                      }, null, 8, ["modelValue", "placeholder", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { prop: "duration" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: scheduleRecord.value.duration,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((scheduleRecord.value.duration) = $event)),
                        placeholder: _unref(t)('Evses.duration'),
                        disabled: props.isView,
                        type: "number",
                        min: 0
                      }, null, 8, ["modelValue", "placeholder", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "minChargingRateInfo",
                    required: "",
                    rules: profileScheduleFormRule.value.minChargingRateInfo
                  }, {
                    default: _withCtx(() => [
                      _createVNode(InputWithUnit, {
                        modelValue: scheduleRecord.value.minChargingRateInfo,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((scheduleRecord.value.minChargingRateInfo) = $event)),
                        numberPlaceholder: _unref(t)('Evses.minChargingRate'),
                        units: [
              { label: 'A', value: 'A' },
              { label: 'W', value: 'W' },
            ],
                        defaultUnit: defaultUnit.value,
                        disabled: props.isView
                      }, null, 8, ["modelValue", "numberPlaceholder", "defaultUnit", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: 24,
            style: { height: '16px' }
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table, {
                data: scheduleRecord.value.chargingSchedulePeriod,
                class: "shadow-none",
                "row-style": { height: '56px' },
                "max-height": 720
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('Evses.startPeriod')
                  }, {
                    default: _withCtx(({ row, $index }) => [
                      _createVNode(_component_el_form_item, {
                        prop: `chargingSchedulePeriod.${$index}.startPeriod`,
                        rules: profileScheduleFormRule.value.startPeriod
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: row.startPeriod,
                            "onUpdate:modelValue": ($event: any) => ((row.startPeriod) = $event),
                            disabled: props.isView,
                            placeholder: "e.g., 0, 3600",
                            type: "number",
                            min: 0
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('Evses.numberPhases')
                  }, {
                    default: _withCtx(({ row, $index }) => [
                      _createVNode(_component_el_form_item, {
                        prop: `chargingSchedulePeriod.${$index}.numberPhases`,
                        rules: profileScheduleFormRule.value.numberPhases
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: row.numberPhases,
                            "onUpdate:modelValue": ($event: any) => ((row.numberPhases) = $event),
                            disabled: props.isView,
                            placeholder: "e.g., 0, 1, 2 ,3",
                            type: "number",
                            min: 0,
                            max: 3
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('Evses.limit')
                  }, {
                    default: _withCtx(({ row, $index }) => [
                      _createVNode(_component_el_form_item, {
                        prop: `chargingSchedulePeriod.${$index}.limit`,
                        rules: profileScheduleFormRule.value.limit
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: row.limit,
                            "onUpdate:modelValue": ($event: any) => ((row.limit) = $event),
                            disabled: props.isView,
                            placeholder: "e.g., 8",
                            type: "number",
                            min: 0
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        _: 2
                      }, 1032, ["prop", "rules"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  (__props.isView == false)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        width: "80"
                      }, {
                        header: _withCtx((scope) => [
                          _createVNode(_component_el_button, {
                            size: "small",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (addTabdata())),
                            disabled: disableAdd(scope) || !_ctx.$hasPermission('post')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('Base.add')), 1)
                            ]),
                            _: 2
                          }, 1032, ["disabled"])
                        ]),
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_el_button, {
                            size: "small",
                            disabled: !_ctx.$hasPermission('delete'),
                            onClick: ($event: any) => (delTabdata(row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('Base.delete')), 1)
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})